import type { StateCreator } from "zustand";
import type { loadingState } from "./loadingSlice";
import { toast } from "sonner";
import { apiService } from "@/service/api";
import { authSessionState } from "./authSessionSlice";
import { COUNTRIES, type Country } from "@/data/countries";

export interface onboardingState {
  countries: Country[],
  companyName: string,
  region: string,
  country: string,
  companySize: number | null,
  getCountries: () => void,
  getCurrentOrganization: () => Promise<void>,
  updateFormDetails: (values: { companyName: string; country: string; companySize: number | null }) => void,
  createOrganization: (companyName: string, country?: string, companySize?: number | null) => Promise<void>,
}

export const initialOnboardingState = {
  countries: [],
  companyName: '',
  region: '',
  country: '',
  companySize: null,
}

export const onBoardingSlice: StateCreator<onboardingState & loadingState & authSessionState, [], [], onboardingState> = (set, get) => ({
  ...initialOnboardingState,

  getCountries: () => {
    // Country list is bundled statically (see @/data/countries); no network fetch.
    set({ countries: COUNTRIES });
  },

  getCurrentOrganization: async () => {
    set({ companyName: '' });
  },

  updateFormDetails: ({ 
    companyName,
    country,
    companySize,
  }) => {
    set({ 
      companyName,
      country,
      companySize,
    });
  },

  createOrganization: async (companyName: string, country?: string, companySize?: number | null) => {
    const { setLoading, refreshUserSession } = get()

    try {
      setLoading(true)

      await apiService.createOrganization({
        name: companyName,
        country: country || null,
        size: companySize || null
      })

      await refreshUserSession()
      toast.success('Organization created successfully!')

    } catch (error) {
      await refreshUserSession()
      console.error('Error creating organization:', error)
      toast.error('Failed to create organization. Please try again.')
      throw error // Re-throw to allow caller to handle
    } finally {
      setLoading(false)
    }
  }
});